import { ChevronRight } from 'lucide-react'

/**
 * Riga di trigger per il gruppo "field-rows" (Pratica / Smart List / Note).
 * Visual: icona a sinistra · label · value muted o accent · chevron.
 * Stile cohesivo con gli altri se usata dentro <div className="field-rows">.
 *
 * Props:
 *   icon       — ReactNode (icona lucide o simile)
 *   label      — string
 *   value      — string (mostrato a destra, può essere "Nessuna", "Crea", count, preview)
 *   accent     — boolean: se true, value usa colore primary (CTA "Crea"/"Aggiungi")
 *   onClick    — handler
 *   disabled   — boolean
 */
export default function FieldRow({ icon, label, value, accent, onClick, disabled, ariaLabel }) {
  return (
    <button
      type="button"
      className="field-row"
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel || label}
    >
      <span className="field-row-icon">{icon}</span>
      <span className="field-row-label">{label}</span>
      {value && (
        <span className={`field-row-value${accent ? ' field-row-value--accent' : ''}`}>
          {value}
        </span>
      )}
      <ChevronRight size={16} className="field-row-chevron" />
    </button>
  )
}
